/**
* 系统管理 菜单管理
*/
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工程用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formCustomer" class="user-search">

      <el-form-item label="客户姓名">
        <el-input size="small" v-model="formCustomer.name" placeholder="输入客户姓名"></el-input>
      </el-form-item>
      <el-form-item label="客户状态">
        <el-select size="small" v-model="formCustomer.status" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="拜访用户" value="拜访用户"></el-option>
          <el-option label="准意向用户" value="准意向用户"></el-option>
          <el-option label="成交用户" value="成交用户"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户手机">
        <el-input size="small" v-model="formCustomer.mobile" placeholder="输入手机号码"></el-input>
      </el-form-item>
      <!-- <el-form-item label="创建人">
    	    <el-input size="small" v-model="formCustomer.creatorName" placeholder="输入创建人"></el-input>
    	  </el-form-item>
          <el-form-item label="创建时间">
    	    <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
    	  </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="customerList" highlight-current-row
      v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column fixed align="center" sortable prop="customerName" label="客户姓名" width="120">
      </el-table-column>
      <!-- <el-table-column align="center" sortable prop="customerGender" label="客户性别" width="120">

      </el-table-column> -->
      <!-- <el-table-column align="center" sortable prop="customerGender" label="客户性别" width="120" :formatter="contentTypeFormatter">
            
          </el-table-column> -->
      <el-table-column align="center" sortable prop="customerMobile" label="电话号码" width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="customerFrom" label="发展来源" width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="customerDealersName" label="所属经销商" min-width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="customerSalesmanName" label="业务代表" min-width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="customerZzdbName" label="驻镇代表" min-width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="customerStatus" label="客户状态" min-width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="customerSigned" label="是否签约" min-width="120">
      </el-table-column>
      <!-- <el-table-column align="center" sortable prop="editTime" label="修改时间" min-width="120">
            <template slot-scope="scope">
              <div>{{scope.row.editTime|timestampToTime}}</div>
            </template>
</el-table-column> -->
      <!-- <el-table-column align="center" sortable prop="status" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
              </el-switch>
            </template>
          </el-table-column> -->
      <el-table-column align="center" label="操作" width="120">
        <template slot-scope="scope">

          <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          <!-- <el-button size="mini" type="success" @click="deleteProInfo(scope.$index, scope.row)">分配</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" class="" justify="space-between" >
      <el-col  :span="20">
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-col>
      <el-col :span="2">
        <el-button size="small" style="margin-top:10px;" type="primary"  @click="assignCustomerList">分配客户</el-button>
      </el-col>
    </el-row>
    <div >
        

        
    </div>
    
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="70%" @click='closeDialog("edit")'>

      <el-form :inline="true" label-width="150px" ref="editForm" :model="editForm">

        <el-form-item label="客户头像" prop="customerName" style="width: 100%;">
          <el-image style="width: 100px; height: 100px" :src="editForm.customerIconUrl" fit="fill">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <!-- <el-upload
            class="avatar-uploader"
            :action="uploadUrl()"
            :http-request="customUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="resultFilelist1"
            :limit='1'
            accept=".png,.jpg,.jpeg"
            list-type="picture"
            :show-file-list="false">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload> -->
        </el-form-item>
        <el-form-item label="客户姓名" prop="customerName">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerName" auto-complete="off"
            placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="客户电话号码" prop="customerMobile">
          <el-input :disabled="disabled" :maxlength="11" size="small" v-model="editForm.customerMobile" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户来源" prop="customerFrom">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerFrom" auto-complete="off" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户的所属经销商" prop="customerDealersName">
          <el-input :disabled="true" size="small" v-model="editForm.customerDealersName" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户的所属业务代表" prop="customerSalesmanName">
          <el-input :disabled="true" size="small" v-model="editForm.customerSalesmanName" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户所属驻镇代表" prop="customerZzdbName">
          <el-input :disabled="true" size="small" v-model="editForm.customerZzdbName" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户所在省市县" prop="customerLocal">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerLocal" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户详细地址" prop="customerAddress">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerAddress" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户位置的经度" prop="customerLongitude">
              <el-input :disabled="disabled" size="small" v-model="editForm.customerLongitude" auto-complete="off" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="客户位置的纬度" prop="customerLatitude">
              <el-input  :disabled="disabled" size="small" v-model="editForm.customerLatitude" auto-complete="off" placeholder=""></el-input>
            </el-form-item> -->
        <el-form-item label="是否签约" prop="customerSigned">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerSigned" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户的房产" prop="customerHouse">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerHouse" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户的抽奖信息" prop="customerRaffle">
              <el-input :disabled="disabled" size="small" v-model="editForm.customerRaffle" auto-complete="off" placeholder=""></el-input>
            </el-form-item> -->
        <el-form-item label="客户的汽车" prop="customerCar">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerCar" auto-complete="off" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="客户的设计方案" prop="customerPlan">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerPlan" auto-complete="off" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="申请宣言" prop="customerDeclaration" style="width: 100%;">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerDeclaration" auto-complete="off"
            placeholder=""></el-input>
        </el-form-item>

        <!-- <el-form-item label="客户性别" :prop="editForm.customerGender">
              <el-radio v-model="editForm.introductionType" label="0">男</el-radio>
              <el-radio v-model="editForm.introductionType" label="1">女</el-radio>
            </el-form-item> -->
        <!-- <el-form-item label="客户来源" :prop="editForm.customerFrom">
          <el-input :disabled="disabled" size="small" v-model="editForm.customerFrom" auto-complete="off"
            placeholder=""></el-input> -->
          <!-- <el-radio :disabled="disabled"  v-model="editForm.customerFrom" label="经销商">经销商</el-radio>
          <el-radio :disabled="disabled"  v-model="editForm.customerFrom" label="业务代表">业务代表</el-radio>
          <el-radio :disabled="disabled"  v-model="editForm.customerFrom" label="驻镇代表">驻镇代表</el-radio>
          <el-radio :disabled="disabled"  v-model="editForm.customerFrom" label="销售人员">销售人员</el-radio> -->
        </el-form-item>
        <el-form-item :disabled="disabled"  label="客户状态" :prop="editForm.customerStatus" style="width: 100%;">
          <el-radio v-model="editForm.customerStatus" label="拜访用户">拜访用户</el-radio>
          <el-radio v-model="editForm.customerStatus" label="准意向用户">准意向用户</el-radio>
          <el-radio v-model="editForm.customerStatus" label="成交用户">成交用户</el-radio>
        </el-form-item>
      </el-form>



      <div slot="footer" class="dialog-footer" v-if="!editForm.customerDealersName">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
      </div>
    </el-dialog>



    <!-- 分配界面 -->
    <el-dialog title="分配经销商" :visible.sync="assignFormVisible" width="70%" @click='closeDialog("assign")'>

      <el-form :inline="true" :model="searchDealersForm">

        <el-form-item label="经销商名称">
          <el-input size="small" v-model="searchDealersForm.name" placeholder="输入经销商名称"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="small" v-model="searchDealersForm.phoneNumber" placeholder="输入手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getDealersList">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table size="small" height="350" :data="dealersList" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">

        <el-table-column align="center" sortable prop="name" label="经销商姓名">
        </el-table-column>
        <el-table-column align="center" sortable prop="agencyCode" label="经销商代码">

        </el-table-column>

        <el-table-column align="center" sortable prop="tytPhone" label="电话号码">
        </el-table-column>
        <el-table-column align="center" sortable prop="address" label="地址">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="assign(scope.$index, scope.row)">分配</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div slot="footer" class="dialog-footer" >
                <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
              </div> -->
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import { uploadFile } from '../../api/axiosFun';
import {
  modifyCustomerInfo,
  getCustomerInfo,
  getCustomerList,
  getDealersList,
  customerAssign,
  distributorList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'


import { evaluateUpload } from '@/api/auth';
import { setCookie, getCookie, delCookie } from '../../utils/util'



export default {
  data() {
    return {
      assignFormVisible: false,
      dateValue: [],
      textarea2: '',
      loading: false, //是显示加载
      title: '',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      disabled:false,
      // 编辑与添加
      editForm: {
        createTime: '',
        creatorId: '',
        customerAddress: '',
        customerDealersIdv: '',
        customerDealersName: '',
        customerDeclaration: '',
        customerFrom: '',
        customerLatitude: '',
        customerLocal: '',
        customerLongitude: '',
        customerMobile: '',
        customerName: '',
        customerSalesmanId: '',
        customerSalesmanName: '',
        customerSigned: '',
        customerStatus: '',
        customerZzdbId: '',
        customerZzdbName: '',
        customerIconUrl: '',
        id: '',
        userId: ''
      },

      // 选择数据
      selectdata: [],


      // 请求数据参数
      formCustomer: {
        pageIndex: 1,
        pageSize: 10,
        name: '',
        mobile: '',
        status: '',
        code: '',
		customerType:'工程用户'
      },
      searchDealersForm: {
        name: '',
        phoneNumber: '',
        pageIndex: 1,
        pageSize: 999999
      },
      //客户介绍列表
      customerList: [],


      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      diaFrom: {
        desc: '',
        list: []
      },
      resultFilelist: [],
      resultFilelist1: [],
      fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }],
      dealersList: []

    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getData(this.formCustomer)
    this.getDealersList()
  },
  mounted() {
    // document.addEventListener("paste", this.handlePaste);
  },
  beforeDestroy() {
    // document.removeEventListener("paste",this.handlePaste);
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getDealersList() {
      this.loading = true
      getDealersList(this.searchDealersForm).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg + 'TraceId:' + res.traceId
          })
        } else {
          this.dealersList = res.data
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取用户失败，请稍后再试！' + 'TraceId:' + err.traceId)
      })
    },
    assignCustomerList(){
        console.log(this.selectdata)
        let hasDealers = '【'
        let hasDealersFlag = false
        this.selectdata.map((item,index)=>{
          if(item.customerDealersName){
            hasDealersFlag = true
            hasDealers = hasDealers + item.customerName + '、'
          }
      })
      if(hasDealersFlag){
            hasDealers = hasDealers +  '】'
            return this.$message.error('客户' + hasDealers +'已分配经销商，请重新选择')
      }
        if(this.selectdata.length < 1){
          this.$message.error('请至少选择一个客户')
        }else{
          this.assignFormVisible = true
        }
    },
    assign(index,row){
      let customerIdList = []
      let customerNameStr = '【'
      this.selectdata.map((item,index)=>{
        customerIdList.push(item.id)

        if(index == (this.selectdata.length - 1)){
          customerNameStr = customerNameStr + item.customerName + '】'
        }else{
          customerNameStr = customerNameStr + item.customerName + '、'
        }
        
      })
      let data = {
        dealersId:row.id,
        dealersName:row.name,
        customerIdList:customerIdList
      }
      this.open(customerNameStr,data)
      console.log(row)
    },
    open(customerNameStr,data){
      let _this = this 
        this.$confirm('此操作将客户'+customerNameStr+'分配给经销商【'+ data.dealersName +'】, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          _this.customerAssign(data)
        }).catch(() => {
          
        });
      },
    customerAssign(data){
      customerAssign(data).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg + 'TraceId:' + res.traceId
          })
        } else {
          //重置经销商信息
          this.searchDealersForm = {
            name: '',
            phoneNumber: '',
            pageIndex: 1,
            pageSize: 999999
          }
          this.getDealersList()
          this.assignFormVisible = false
          this.getData(this.formCustomer)
          this.$message({
            type: 'success',
            message: '客户分配成功'
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取用户失败，请稍后再试！' + 'TraceId:' + err.traceId)
      })
    },
    contentTypeFormatter(row, column) {
      let contentTypeName = row.contentType == 0 ? '链接' : row.contentType == 1 ? '图文' : '文件'
      return contentTypeName

    },
    editFormInit() {
      this.editForm = {
        id: '',
        customerName: '',
        productType: '0',
        introductionType: '0',
        contentType: '0',
        description: '',
        content: [],
        linkUrl: '',
        attachments: [],
      }
      this.resultFilelist1 = []
      this.resultFilelist = []
    },
    // async handlePaste(event){
    //   const clipboardData = event.clipboardData || window.clipboardData;
    //   if(clipboardData){
    //     const items = clipboardData.items;
    //     if(items && items.length >0){
    //       for(let i=0;i<items.length; i++){
    //         const item = items[i];
    //         if(item.kind === 'file' && item.type.startsWith('image/')){
    //           const file = item.getAsFile();
    //           const formData= new FormData();
    //           formData.append('file', file);
    //           if(file){
    //              evaluateUpload(formData,{
    //               token: this.$util.cookies.token,
    //               userId:this.info ? this.info.userId :''
    //             }).then((response)=>{
    //               const { data, code }=response.data || {};
    //               // 11 上传成功，应该返回
    //               if(code ==='APPLY SUCCESS'){
    //                 if(data){
    //                   this.resultFilelist.push({
    //                     url: data.url,
    //                     name: data.name,
    //                     uid: file.uid
    //                   });
    //                 console.log(this.resultFilelist,'剪贴成功数据');
    //               }else if(response && response.msg){
    //                  console.log('upload failed',response.msg); 
    //                 }
    //              }
    //             }).catch((error)=>{console.log(error)
    //             });
    //           }
    //         }
    //       }
    //     }
    //   }
    // },

    //限制上传个数不超过9个
    handleExceed(files, fileList) {
      if (fileList && fileList.length == 1) {
        this.$message.warning('上传文件不可超过1个')
      }
    },
    handlePreview(file) {
      console.log(file)
    },
    beforeAvatarUpload(file) {
      console.log(file)
    },
    customUpload(req) {
      let _this = this
      console.log(req)
      // 创建一个新的FormData对象
      const formData = new FormData();
      // 将文件添加到formData中
      formData.append('file', req.file);

      uploadFile(this.uploadUrl(), formData).then(response => {
        console.log(response.data.success)
        if (response.data.success) {
          let data = response.data.data
          console.log(data)
          // _this.editForm.attachments.push(data)
          if (_this.editForm.contentType == 2) {
            _this.resultFilelist.push({
              url: require('../../assets/img/pdf.png'),
              fileTemporaryUrl: data.fileTemporaryUrl,
              fileId: data.fileId,
              name: data.ossFile.fileName,
              uid: req.file.uid,
              attachments: data
            })
            this.dealPDF();
            setTimeout(() => {
              this.dealPDF();
            }, 1);
          } else if (_this.editForm.contentType == 1) {
            _this.resultFilelist1.push({
              url: data.fileTemporaryUrl,
              fileTemporaryUrl: data.fileTemporaryUrl,
              fileId: data.fileId,
              name: data.ossFile.fileName,
              uid: req.file.uid,
              mediaObjInfo: data
            })

          }

        } else {
          console.log('???')
          this.$message.error('文件上传失败，请稍后再试！')
        }


        console.log(_this.resultFilelist)
        // 处理响应
      }).catch(error => {
        // 处理错误
        console.log(error)
        //  this.$message.error('文件上传失败，请稍后再试！')
      });
    },
    handleRemove(file, fileList) {
      console.log(file)
      if (!file) {
        return
      }

      if (this.editForm.contentType == 2) {
        const index = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
        this.resultFilelist.splice(index, 1);
      } else if (this.editForm.contentType == 1) {
        const index1 = this.resultFilelist1.findIndex(item => item.fileId === file.fileId)
        this.resultFilelist1.splice(index, 1);
      }

    },
    onUploadSuccess(response, file, fileList) {
      console.log('onUploadSuccess', response)
    },
    uploadUrl() {
      return '/mtl/marking/api/main/oss-file/upload-file'
    },
    dealPDF() {
      var liElements = document.querySelectorAll('ul.el-upload-list,el-upload-list--picture li.el-upload-list__item');
      liElements.forEach(function (liElement) {
        var aElement = liElement.querySelector('a.el-upload-list__item-name');
        if (aElement && (aElement.textContent.includes('.pdf') || aElement.textContent.includes('.doc') || aElement.textContent.includes('.docx') || aElement.textContent.includes('.ppt') || aElement.textContent.includes('.pptx'))) {
          var imgElement = liElement.querySelector('img.el-upload-list__item-thumbnail')
          if (imgElement) {
            imgElement.src = require('../../assets/img/pdf.png');// 普换为你想要的新图片的URL
          }
        }
      })
    },

    // 获取数据方法
    getDatas(index, row) {
      this.loading = true

      let pageparm = {
        pageIndex: 1,
        pageSize: 10,
        name: '',
        parentMenuCode: ''
      }
      console.log(777, row)
      if (row != undefined && row != 'undefined') {
        pageparm.parentMenuCode = row
      }

      ModuleNodes(pageparm).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.customerList = res.data.data
          console.log(this.customerList)

          // 分页赋值
          this.pageparm.pageIndex = this.formCustomer.pageIndex
          this.pageparm.pageSize = this.formCustomer.pageSize
          this.pageparm.total = res.data.data.total
        }
      })
    },
    // 获取数据方法
    getData(pageparm) {
      this.loading = true
      console.log(pageparm)
      if (this.dateValue.length > 0) {
        pageparm.createStartTime = this.dateValue[0]
        pageparm.createEndTime = this.dateValue[1]
      }

      getCustomerList(pageparm).then(res => {
        console.log(res)
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.customerList = res.data.data

          // 分页赋值
          this.pageparm.currentPage = this.formCustomer.pageIndex
          this.pageparm.pageSize = this.formCustomer.pageSize
          this.pageparm.total = res.data.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formCustomer.pageIndex = parm.currentPage
      this.formCustomer.pageSize = parm.pageSize
      this.getData(this.formCustomer)
    },
    //搜索事件
    search() {
      console.log(123)
      console.log(this.dateValue)
      this.formCustomer.pageIndex = 1
      this.getData(this.formCustomer)
    },


    // 修改type
    editType: function (index, row) {
      this.loading = true
      let parm = {
        menuCode: '',
        status: ''
      }
      parm.menuCode = row.menuCode
      let lock = row.status
      console.log(55, lock)
      if (lock == 0) {
        parm.status = 1
      } else {
        parm.status = 0
      }
      // 修改状态
      Modulestate(parm).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'success',
            message: '状态修改成功'
          })
          this.formCustomer.parentMenuCode = row.parentCode
          this.getData(this.formCustomer)
        }
      })
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '客户详情'
        this.disabled = true
        getCustomerInfo(row.id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg + 'TraceId:' + res.traceId
              })
            } else {
              console.log(res)

                this.editForm = {
                  ...res.data
                }
            }
          })

      } else {
        this.title = '添加客户'
        this.disabled = false
        this.editFormInit()
      }
    },
    // 编辑、添加提交方法
    saveProInfo() {
      console.log(this.content)
      if (!this.editForm.customerName) {
        return this.$message({
          type: 'warning',
          message: '请填写客户姓名'
        })
      }

      let parm = {
        customerName: this.editForm.customerName,
        productType: parseInt(this.editForm.productType),
        introductionType: parseInt(this.editForm.introductionType),
        contentType: parseInt(this.editForm.contentType)
      }
      if (parm.contentType == 0) {
        // let linkReg =  /^(?:(http|https|ftp):\/\/)?((|[\w-]+\.)+[a-z0-9]+)(?:(\/[^/?#]+)*)?(\?[^#]+)?(#.+)?$/i
        let linkReg = /^((https?|ftp|http):\/\/)?(([\w-]+\.)+[A-Za-z]{2,}|((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}:[0-9]{2,5})([\w-]+\.\/?%&!;#,=|]*)?$/i
        const isLink = linkReg.test(this.editForm.linkUrl)
        // console.log(this.editForm.linkUrl)
        // console.log(isLink)
        if (!isLink) {
          return this.$message({
            type: 'warning',
            message: '请填写正确的链接地址'
          })
        }
        parm = {
          ...parm,
          linkUrl: this.editForm.linkUrl
        }
        // parm.append('linkUrl', this.editForm.url);
      } else if (parm.contentType == 1) {
        if (this.resultFilelist1.length < 1) {
          return this.$message({
            type: 'warning',
            message: '请上传图片'
          })
        }
        let content = []
        this.resultFilelist1.map((item, index) => {
          content.push({
            remarks: '',
            mediaObjInfo: item.mediaObjInfo
          })
        })
        parm = {
          ...parm,
          content: content,
          description: this.editForm.description
        }
      } else if (parm.contentType == 2) {
        if (this.resultFilelist.length < 1) {
          return this.$message({
            type: 'warning',
            message: '请上传文件'
          })
        }
        let attachments = []
        this.resultFilelist.map((item, index) => {
          attachments.push(item.attachments)
        })
        parm = {
          ...parm,
          attachments: attachments
        }
      }
      if (this.editForm.id) {
        parm = {
          ...parm,
          id: this.editForm.id
        }
      }
      console.log(parm)
      if (this.title == '客户详情') {
        modifyCustomerInfo(parm)
          .then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.success) {
              this.getData(this.formCustomer)
              this.editFormInit()
              this.$message({
                type: 'success',
                message: '保存成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('保存失败，请稍后再试！')
          })
      } else {


        createProInfo(parm)
          .then(res => {
            this.loading = false
            this.editFormVisible = false
            if (res.success) {
              this.getData(this.formCustomer)
              this.editFormInit()
              this.$message({
                type: 'success',
                message: '保存成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('保存失败，请稍后再试！')
          })
      }
      // } else {
      //   return false
      // }
      // })
    },

    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },

    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
      console.log(val)
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 删除用户
    deleteProInfo(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          deleteProInfo(row.id)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.getData(this.formCustomer)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.main {
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
}

.avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    }
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/system/engineering.vue